import {WX_OPEN_ID,WX_CODE} from '../../constant/CookieKeys'
import * as Cookie from 'tiny-cookie'
import {wx_jump_url} from './share'
import {getJSON} from '../../api/myaxios'

function fetch_wx_openid(wx_code) {
  if (!wx_code) {
    return;
  }
  //已经用过1次了
  if (Cookie.get(WX_CODE) === wx_code) {
    return;
  }
  Cookie.set(WX_CODE, wx_code);
  getJSON(`//vipact3.api.mgtv.com/api/v1/act/wx/openid?code=${wx_code}`)
    .then(res => {
      if (res.ret === 0) {
        Cookie.set(WX_OPEN_ID, res.data, {expires: '3h'})
      }
    })

}

export default function get_open_id(){
  console.log('get_open_id')
  const code = get_param('code');
  const wx_openid = Cookie.get(WX_OPEN_ID);
  if(wx_openid){
    return;
  }
  if (code) {
    fetch_wx_openid(code);
  } else if (wx_openid === null) {
    //如果没有code 并且wx_openid也无法获得 才需要跳转
    window.location.href = wx_jump_url()
  }

}
